/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
import { axios } from '@/../utils';

export const namespaced = true;

const getDefaultState = () => {
    return {
        // shortlist: [{"id":1583924991657,"panel":{"id":11,"uid":"1957d895-f6f8-4461-bdb8-3aa312ec8859","dateCreated":"2020-03-10 14:39:07","dateUpdated":"2020-03-10 14:41:49","ownerId":"0039000002IlYBBAA3","type":"pvModule","model":"HOGJ-M2-290-60C","manufacturer":"Tianjin HuanOu International Silicon Material Co Ltd","salesforceId":"a079000000qGcQXAA0","companyId":"0019000001xIV3IAAW","details":{"powerRating":"9","moduleEfficiency":"0.09","powerToleranceLower":"9","powerToleranceUpper":"9","voc":"9","panelIsc":"2.666","vmp":"9","imp":"9","vDeratingCelsius":"1","iDerating":"1","pDerating":"1","maxSystemVoltage":"9","seriesFuseRating":"9","panelDimensionsLength":"9","panelDimensionsWidth":"9","panelDimensionsHeight":"9","weight":"9","connectorManufacturer":"9","connectorType":"9"},"expiry":"2021-04-18 10:00:00","expired":0,"valid":1}},{"id":1583925040417,"panel":{"id":1,"uid":"26cecac2-c6f8-4d92-91a7-d3ef1ccfb3ee","dateCreated":"2020-03-06 04:27:34","dateUpdated":"2020-03-06 04:49:20","ownerId":"0039000002IlYBBAA3","type":"pvModule","model":"STM6-270/60","manufacturer":"Anhui Schutten Solar Energy Co Ltd","salesforceId":"a079000000pbSuTAAU","companyId":"0019000001xIV3IAAW","details":{"powerRating":"201","powerToleranceLower":"201","powerToleranceUpper":"201","moduleEfficiency":"0.8","voc":"201","panelIsc":"201","vmp":"201","imp":"201","vDeratingCelsius":"0.5","iDerating":"0.5","pDerating":"0.5","maxSystemVoltage":"200","seriesFuseRating":"200","panelDimensionsLength":"","panelDimensionsWidth":"","panelDimensionsHeight":"","weight":"","connectorManufacturer":"","connectorType":""},"expiry":"2021-04-26 10:00:00","expired":0,"valid":1}}],
        shortlist: [{ id: Date.now() }],
        inverters: [],
        panels: [],
    };
};

export const state = getDefaultState();

export const mutations = {
    SET_SAVED_INVERTERS(state, payload) {
        state.inverters = payload;
    },

    SET_SAVED_PANELS(state, payload) {
        state.panels = payload;
    },

    ADD_TO_SHORTLIST(state) {
        state.shortlist.push({
            id: Date.now()
        });
    },

    UPDATE_SHORTLIST(state, item) {
        state.shortlist = [
            ...state.shortlist.filter(prod => prod.id != item.id),
            item
        ];
    },

    REMOVE_FROM_SHORTLIST(state, id) {
        state.shortlist = state.shortlist.filter((product) => product.id != id);
    },

    RESET_STATE(state) {
        Object.assign(state, getDefaultState());
    }
};

export const actions = {
    fetchProducts({ dispatch }) {
        dispatch('fetchSavedInverters');
        dispatch('fetchSavedPanels');
    },

    async fetchSavedInverters({ commit, state }) {
        if (state.inverters.length) return;

        try {
            const { data: { data: { products }} } = await axios.get('/api/user/products.json?type=inverter');
            commit('SET_SAVED_INVERTERS', products);
        } catch (err) {
            // console.log(err);
        }
    },

    async fetchSavedPanels({ commit }) {
        if (state.panels.length) return;

        try {
            const { data: { data: { products }} } = await axios.get('/api/user/products.json?type=pvModule');
            commit('SET_SAVED_PANELS', products);
        } catch (err) {
            // console.log(err);
        }
    },

    addToShortlist({ commit }) {
        commit('ADD_TO_SHORTLIST');
    },

    updateShortlist({ commit }, item) {
        commit('UPDATE_SHORTLIST', item);
    },

    removeFromShortlist({ commit }, id) {
        commit('REMOVE_FROM_SHORTLIST', id);
    },

    resetState({ commit }) {
        commit('RESET_STATE');
    }
};

export const getters = {
    panelSimpleArray: (state) => state.shortlist.map((item) => item.panel),

    productIDs: (state, getters, rootState) => {
        const inverters = rootState.configuration.systems.map((system) => system.inverter.salesforceId);
        const panels = getters.panelSimpleArray.map((panel) => panel.salesforceId);
        return [...inverters, ...panels];
    }
};
